export const SHIPMENT = 'Shipment';
export const EXTERNAL = 'External';
